import { render, staticRenderFns } from "./PayrollBatchList.vue?vue&type=template&id=71244e02&scoped=true"
import script from "./PayrollBatchList.vue?vue&type=script&lang=js"
export * from "./PayrollBatchList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71244e02",
  null
  
)

export default component.exports